import styled from 'styled-components'

export const SubmenuDesktop = styled.ul`
  /* Auto Layout */
  display: ${props => (props.visible ? 'block' : 'none')};
  flex-direction: row;
  padding: 16px 0 16px 0;

  position: absolute;
  width: 240px;
  left: -50px;
  top: 73px;
  list-style: none;
  z-index: 4;

  /* Neutral/00 */
  background: ${props => props.theme.colors.white};

  /* Shadow/01 */
  box-shadow: 0px 2px 2px rgba(22, 22, 22, 0.04), 0px 4px 8px rgba(22, 22, 22, 0.08);

  border-radius: 4px;
`

export const SubmenuItem = styled.li`
  color: ${props => props.theme.colors.white};
  height: 40px;
  cursor: pointer;
  &:hover {
    background-color: rgba(22, 22, 22, 0.04);
  }
`

export const SubmenuLink = styled.a`
  /* ✏️ List item */
  position: static;
  width: 100%;
  display: block;
  height: 100%;
  left: 16px;
  top: 8px;

  /* Desktop/Body/SM */
  font-family: ${props => props.theme.font};
  font-size: 14px;
  /* identical to box height, or 24px */

  /* Brand/Primary/40 (base) */
  color: ${props => props.theme.menu.text};


  /* Inside Auto Layout */
  flex: none;
  order: 1;
  flex-grow: 1;
  margin: 0px 16px 0px 16px;

  text-decoration: none;
`
